import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { getLocale } from "react-i18nify";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Rating from "@mui/material/Rating";
import { Alert } from "@mui/material";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import ModalConfirm from "../ui/ModalConfirm";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import PhotoCameraOutlinedIcon from "@mui/icons-material/PhotoCameraOutlined";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import UploadImage from "./dropzone/UploadImage";
import UploadVideo from "./dropzone/UploadVideo";
import { getAllSuggestComments } from "src/api/suggestComment";
import { searchProduct } from "src/api/product";
import { formatFromElastic } from "src/common";
import { createReview, getReviewDetail, updateReview } from "src/api/review";
import DeleteIcon from "@mui/icons-material/Delete";
import Loading from "../ui/Loading";

const Modal = styled.div`
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1200;
  animation: show 0.5s;
  @keyframes show {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;
const WrapperModal = styled.div`
  max-width: 950px;
  // width: 100%;
  width: -webkit-fill-available;
  background-color: #ffffff;
  border-radius: 24px;
  box-shadow:
    0px 11px 15px -7px rgba(0, 0, 0, 0.2),
    0px 24px 38px 3px rgba(0, 0, 0, 0.14),
    0px 9px 46px 8px rgba(0, 0, 0, 0.12);
  // width: fit-content;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  padding: 30px 25px;
  min-width: 932px;
  animation: showModal 0.5s;
  @keyframes showModal {
    0% {
      transform: translate(-50%, -60%);
    }
    100% {
      transform: translate(-50%, -50%);
    }
  }
`;

const WrapperModalInside = styled.div`
  width: 100%;
  height: auto;
  overflow-y: scroll;
  overflow-x: hidden;
  /* margin-top: 16px; */
  margin-bottom: 16px;
  /* margin-left: 16px; */
  /* margin-right: 16px; */
  ::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #b9b9b9;
    border-radius: 100px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #b9b9b9;
  }
  ::-webkit-scrollbar-corner {
    background: transparent;
  }
  &:focus {
    outline: none;
  }

  .Button-New-Brand {
    color: #ffffff;
    width: 98%;
    margin: 8px;
    display: flex;
    justify-content: center;
    background: #e04132;
    box-shadow:
      0px 3px 1px -2px rgba(0, 0, 0, 0.2),
      0px 2px 2px rgba(0, 0, 0, 0.14),
      0px 1px 5px rgba(0, 0, 0, 0.12);
    border-radius: 16px;
    height: 52px;
    padding: 0 16px;
  }
  .Button-New-Brand:focus {
    background-color: #e04132;
  }
  .Button-New-Brand:hover {
    background-color: #e04132;
    opacity: 0.9;
  }
`;

const WrapperClose = styled.div`
  justify-content: flex-end;
  width: 10%;
  position: absolute;
  display: flex;
  top: 12px;
  right: 12px;
`;

const WrapperTextField = styled.div`
  // margin-bottom: 16px;
  margin: auto;
  display: flex;
  justify-content: flex-start;
  width: 100%;

  .TextField-without-border-radius fieldset {
    border-radius: 16px;
    text-align: left;
    // text-align: center;
    // background: #fff;
  }
  .MuiOutlinedInput-input {
    background: #fff;
    text-align: left;
  }
  .MuiInputBase-root-MuiOutlinedInput-root {
    border-radius: 16px;
    background: #fff;
  }
  .MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
    border-radius: 16px;
  }
`;

const WrapperHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  position: relative;
  align-items: center;
`;
const SpanProductName = styled.span`
  color: #252525;
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 4px;
  margin: auto;
`;

const SpanProductColor = styled.span`
  color: #252525;
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 4px;
  margin-right: auto;
`;

const SpanProductCode = styled.span`
  color: #252525;
  font-size: 0.75rem;
  margin: auto;
  font-weight: 300;
  margin-bottom: 4px;
`;

const SpanColorName = styled.span`
  color: #252525;
  font-size: 0.75rem;
  font-weight: 300;
  margin: auto;
  margin-top: 4px;
  margin-bottom: 4px;
`;

const SpanColorCode = styled.span`
  color: #252525;
  font-size: 0.75rem;
  margin: auto;
  font-weight: 300;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-wrap: nowrap;
  max-width: 75px;
`;

const WarpperRating = styled.div`
  & > span > label > span {
    font-size: 1.5rem;
    margin: auto 0;
  }
  & > span > span > span {
    font-size: 1.5rem;
    margin: auto 0;
  }
`;

const WrapperText = styled.div`
  margin: 8px 0;
  color: #252525;
  font-size: 24px;
  font-weight: 500;
  width: 100%;
  position: relative;
  display: flex;
  justify-content: flex-start;
  .TextField-without-border-radius fieldset {
    border-radius: 16px;
  }
`;

const WrapperChooseProduct = styled.div`
  border-radius: 24px;
  width: 455px;
  height: 400px;
  max-height: 400px;
  flex-shrink: 0;
  padding: 16px;
  background-color: #f2f1f3;
  border: 1px solid #f2f1f3;

  overflow-y: scroll;
  overflow-x: hidden;
  ::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 100px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: transparent;
  }
  ::-webkit-scrollbar-corner {
    background: transparent;
  }
  &:focus {
    outline: none;
  }
`;
const WrapperDataReview = styled.div`
  border-radius: 24px;
  width: 455px;
  height: 400px;
  max-height: 400px;
  flex-shrink: 0;
  padding: 16px;
  background-color: #f2f1f3;
  border: 1px solid #f2f1f3;

  overflow-y: scroll;
  overflow-x: hidden;
  ::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 100px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: transparent;
  }
  ::-webkit-scrollbar-corner {
    background: transparent;
  }
  &:focus {
    outline: none;
  }
`;

const DivSection = styled.div`
  display: flex;
  width: 100%;
  margin: auto;
`;

const ImageProduct = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 16px;
  margin: 8px auto;
  object-fit: cover;
`;

const LineDescription = styled.div`
  border-top: 1px solid #d9d9d9;
  margin: 24px 0;
  width: ${({ width }) => width};
  display: ${({ isMobile }) => (isMobile ? "none" : "block")};
`;

const ImgProductColor = styled.img`
  width: 50px;
  height: 50px;
  margin: auto;
  object-fit: cover;
  border-radius: 25px;
`;

const DivTexture = styled.div`
  border: 1px solid;
  padding: 8px 12px;
  border-radius: 20px;
  margin-right: 16px;
  margin-bottom: 16px;
  font-size: 0.75rem;
  font-weight: 300;
  min-width: 50px;
  text-align: center;
`;
const DivSize = styled.div`
  border: 1px solid;
  padding: 8px 12px;
  border-radius: 20px;
  margin-bottom: 16px;
  margin-right: 16px;
  font-size: 0.75rem;
  font-weight: 300;
`;

const TextRating = styled.span`
  color: #6c6c70;
  font-size: 14px;
  font-weight: 400;
`;

const ButtonRate = styled.button`
  padding: 8px 8px;
  align-items: center;
  border-radius: 16px;
  background: ${(props) => (props.selected === true ? `#e13b30` : "#f3f1f2")};
  color: ${(props) => (props.selected === true ? `#fff` : "#6c6c70")};

  font-size: 0.75rem;
  font-weight: 400;
  border: none;
  font-family: inherit;
  margin-right: 12px;
  margin-bottom: 12px;
  cursor: pointer;
  :hover {
    background-color: rgb(224, 65, 50);
    color: #fff;
  }
`;
const VideoCreateReview = styled.video`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 8px;
  justify-content: center;
  width: 100px;
  height: 100px;
  background: #f2f1f3;
  border-radius: 8px;
  object-fit: cover;
  object-position: center;
  cursor: pointer;
  vertical-align: initial;
  &:hover {
    opacity: 0.8;
  }

  &.active {
    border: 2px solid #707070;
  }
`;
const ImageCreateReview = styled.img`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 8px;
  justify-content: center;
  width: 100px;
  height: 100px;
  background: #f2f1f3;
  border-radius: 8px;
  object-fit: cover;
  object-position: center;
  cursor: pointer;
  vertical-align: initial;
  &:hover {
    opacity: 0.8;
  }

  &.active {
    border: 2px solid #707070;
  }
`;
const WrapperAlert = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 3000;
  animation: showAlert 0.5s;
  margin-top: 15px;
  display: flex;
  justify-content: center;
  top: 0;
  left: 0;
  @keyframes showAlert {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;
const DivAlert = styled.div`
  min-width: 320px;
  width: fit-content;
  .MuiPaper-root-MuiAlert-root {
    border-radius: 16px;
  }
`;
const ImageEmpty = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 8px;
  justify-content: center;
  width: 100px;
  height: 100px;
  background: #f2f1f3;
  border-radius: 8px;
  object-fit: cover;
  object-position: center;
  cursor: pointer;
  vertical-align: initial;

  &:hover {
    opacity: 0.8;
  }

  &.active {
    border: 2px solid #707070;
  }
`;

function ModalCreateReview({ visible, onSave, close, title, id }) {
  const [isLoading, setIsLoading] = useState(false);
  const [isVisibleConfirmReview, setIsVisibleConfirmReview] = useState(false);
  const [dataProductList, setDataProductList] = useState([]);
  const [isVisibleConfirmCancel, setIsVisibleConfirmCancel] = useState(false);
  const [suggestVal, setSuggestVal] = useState(5);
  const [dataSuggest, setDataSuggest] = useState([]);
  const [idProduct, setIdProduct] = useState(null);
  const [textReply, setTextReply] = useState("");
  const [isVisibleAlert, setIsVisibleAlert] = useState(false);
  const [titleAlert, setTitleAlert] = useState("");
  const [typeAlert, setTypeAlert] = useState("success");
  const filterOptions = createFilterOptions({
    matchFrom: "any",
    limit: 100,
  });
  const [dataCreateReview, setDataCreateReview] = useState({
    rating: {
      total: 5,
      quality: 5,
      install: 5,
      service: 5,
      deliver: 5,
    },
    groupImage: {
      reviewImage1: "",
      reviewImage2: "",
      reviewImage3: "",
      reviewImage4: "",
      reviewVideo: "",
    },
    sellerId: null,
    userId: null,
    pcId: null,
    name: "",
    suggestId: null,
    comment: "",
    status: "pending",
    isFake: true,
    isHidden: false,
    reply: {
      reply_text: null,
    },
  });

  const closeModal = () => {
    if (titleAlert.length > 0) {
      close(false, true);
    } else {
      close(false);
    }
  };

  useEffect(() => {
    (async () => {
      const { data } = await getAllSuggestComments();
      setDataSuggest(data);
    })();
  }, []);

  useEffect(() => {
    if (id === undefined || id === null) return;
    (async () => {
      const { data } = await getReviewDetail(id);
      setDataCreateReview({
        ...data,
        suggestId: data.suggestId === undefined ? null : data.suggestId?._id,
      });
      setIdProduct({ product_choice_review: data.pcId });
    })();
  }, [id]);

  useEffect(() => {
    (async () => {
      await searchProduct({
        keyword: null,
        first_price: 0,
        last_price: 1000000,
        pageCurrent: null,
        page_size: 10000,
        order: "asc",
        key_order: "default",
        product_type: "",
        brand: "",
        color: "",
        texture: "",
        patterns: "",
        cate: "",
      }).then(async ({ data }) => {
        setDataProductList(
          data?.rows.length > 0
            ? data?.rows?.map((product) => ({
                _id: formatFromElastic(product)._id,
                product_choice_review: formatFromElastic(product),
                volume: 1,
                price:
                  product?.is_start_price === true
                    ? product?.start_price
                    : product?.special_price > 0 &&
                        product?.special_price !== null &&
                        product?.special_price !== undefined
                      ? product?.special_price
                      : product?.price,
              }))
            : [],
        );
      });
    })();
  }, []);

  useEffect(() => {
    const total =
      Number(dataCreateReview.rating.quality) +
      Number(dataCreateReview.rating.service) +
      Number(dataCreateReview.rating.deliver) +
      Number(dataCreateReview.rating.install);

    const cal = Math.floor(total / 4);

    if (cal <= 1) {
      setSuggestVal(1);
      setDataCreateReview({
        ...dataCreateReview,
        rating: {
          ...dataCreateReview.rating,
          total: 1,
        },
      });
    } else if (cal <= 2) {
      setSuggestVal(2);
      setDataCreateReview({
        ...dataCreateReview,
        rating: {
          ...dataCreateReview.rating,
          total: 2,
        },
      });
    } else if (cal <= 3) {
      setSuggestVal(3);
      setDataCreateReview({
        ...dataCreateReview,
        rating: {
          ...dataCreateReview.rating,
          total: 3,
        },
      });
    } else if (cal <= 4) {
      setSuggestVal(4);
      setDataCreateReview({
        ...dataCreateReview,
        rating: {
          ...dataCreateReview.rating,
          total: 4,
        },
      });
    } else if (cal <= 5) {
      setSuggestVal(5);
      setDataCreateReview({
        ...dataCreateReview,
        rating: {
          ...dataCreateReview.rating,
          total: 5,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    dataCreateReview.rating.service,
    dataCreateReview.rating.quality,
    dataCreateReview.rating.deliver,
    dataCreateReview.rating.install,
  ]);

  useEffect(() => {
    setDataCreateReview({
      ...dataCreateReview,
      suggestId: null,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [suggestVal]);

  const onCreateReview = async () => {
    setIsLoading(true);
    if (dataCreateReview._id !== undefined) {
      let save = {
        ...dataCreateReview,
        product_choice: dataCreateReview.pcId
          ? dataCreateReview.pcId._id
          : null,
        rating: JSON.stringify(dataCreateReview.rating),
        reply: dataCreateReview.reply
          ? JSON.stringify(dataCreateReview.reply)
          : null,
      };
      const group = dataCreateReview;

      let data = new FormData();
      if (group.groupImage !== undefined) {
        Object.keys(group.groupImage).map((key) => {
          data.append(`groupImage[${key}]`, group["groupImage"][key]);
          return data;
        });
      }

      Object.keys(save).map((key) => {
        data.append(key, save[key]);
        return data;
      });

      await updateReview(data)
        .then(async (res) => {
          setTitleAlert("Update Success");
          setIsVisibleAlert(true);
          setTypeAlert("success");
          setIsVisibleConfirmReview(false);
          setTimeout(() => {
            (async () => {
              const { data } = await getReviewDetail(id);
              setDataCreateReview({
                ...data,
                suggestId:
                  data.suggestId === undefined ? null : data.suggestId?._id,
              });
              setIdProduct({ product_choice_review: data.pcId });
            })();
            setIsLoading(false);
            setIsVisibleAlert(false);
            close(false, true);
          }, 1500);
        })
        .catch((err) => {
          setIsLoading(false);
          setTitleAlert(err.message);
          setIsVisibleAlert(true);
          setTypeAlert("error");
          setIsVisibleConfirmReview(false);
          setTimeout(() => {
            setIsVisibleAlert(false);
          }, 1500);
        });
    } else {
      let save = {
        ...dataCreateReview,
        product_choice: idProduct?._id,
        rating: JSON.stringify(dataCreateReview.rating),
        reply_text: dataCreateReview.reply.reply_text,
      };
      const group = dataCreateReview;

      let data = new FormData();
      Object.keys(group.groupImage).map((key) => {
        data.append(`groupImage[${key}]`, group["groupImage"][key]);
        return data;
      });

      Object.keys(save).map((key) => {
        data.append(key, save[key]);
        return data;
      });
      await createReview(data)
        .then(async (res) => {
          setTitleAlert("Create Success");
          setIsVisibleAlert(true);
          setTypeAlert("success");
          setIsVisibleConfirmReview(false);
          setTimeout(() => {
            setIsLoading(false);
            setIsVisibleAlert(false);
            close(false, true);
          }, 1500);
        })
        .catch((err) => {
          setIsLoading(false);
          setTitleAlert(err.message);
          setIsVisibleAlert(true);
          setTypeAlert("error");
          setIsVisibleConfirmReview(false);
          setTimeout(() => {
            setIsVisibleAlert(false);
          }, 1500);
        });
    }
  };

  return (
    <Modal>
      <WrapperModal>
        <WrapperClose>
          <HighlightOffRoundedIcon
            sx={{ cursor: "pointer" }}
            onClick={() => {
              if (textReply !== "") {
                setIsVisibleConfirmCancel(true); //showmodal alert cancel
              } else {
                closeModal();
              }
            }}
          />
        </WrapperClose>
        <WrapperModalInside>
          <WrapperHeader>
            <WrapperText>
              {id ? `แก้ไขรีวิวสินค้า` : `สร้างรีวิวสินค้า`}
            </WrapperText>
          </WrapperHeader>
          <WrapperText style={{ marginBottom: "24px" }}>
            <WrapperTextField>
              <Autocomplete
                disabled={id ? true : false}
                aria-required={true}
                id="combo-box-similars"
                filterOptions={filterOptions}
                getOptionSelected={(option, value) => option._id === value._id}
                renderOption={(props, option, { selected }) => (
                  <li
                    {...props}
                    id={`list-product-item-${option._id}`}
                    key={`list-product-item-${option._id}`}
                  >
                    {!!option?.product_choice_review?.group_image
                      ?.product_display_image === false ? (
                      <ImageEmpty>
                        <InsertPhotoIcon
                          sx={{
                            color: "rgba(0, 0, 0, 0.54)",
                            cursor: "pointer",
                          }}
                        />
                      </ImageEmpty>
                    ) : (
                      <img
                        style={{
                          width: "25px",
                          height: "25px",
                          objectFit: "cover",
                          objectPosition: "center",
                          borderRadius: "8px",
                          marginRight: "8px",
                        }}
                        src={
                          option?.product_choice_review?.group_image
                            ?.product_display_image
                            ? option?.product_choice_review?.group_image?.product_display_image.replace(
                                ".com",
                                ".com/75x75",
                              )
                            : ""
                        }
                        alt={
                          option?.product_choice_review?.group_image
                            ?.product_display_image
                        }
                      />
                    )}
                    <div style={{ display: "grid" }}>
                      <span style={{ fontSize: "0.75rem" }}>
                        {option?.product_choice_review?.product?.item_name
                          ? option?.product_choice_review?.product?.item_name +
                            ` - ( ${option?.product_choice_review?.name} )`
                          : "ไม่มีชื่อ"}
                      </span>
                      <span style={{ fontSize: "0.75rem" }}>
                        {option?.product_choice_review?.product?.item_code
                          ? option?.product_choice_review?.product?.item_code
                          : "-"}
                      </span>
                      <span style={{ fontSize: "0.75rem" }}>
                        {option?.product_choice_review?.group_price
                          ?.is_start_price === true
                          ? option?.product_choice_review?.group_price
                              ?.start_price
                          : option?.product_choice_review?.group_price
                                .special_price > 0 &&
                              option?.product_choice_review?.group_price
                                .special_price !== null &&
                              option?.product_choice_review?.group_price
                                .special_price !== undefined
                            ? option?.product_choice_review?.group_price
                                .special_price
                            : option?.product_choice_review?.group_price?.price}
                        {getLocale() === "th"
                          ? ` บาท / ` +
                            option?.product_choice_review?.group_price
                              ?.unit_price?.unit_th
                          : ` baht / ` +
                            option?.product_choice_review?.group_price
                              ?.unit_price?.unit_en}
                      </span>
                    </div>
                  </li>
                )}
                options={dataProductList}
                value={idProduct}
                onChange={(event, newValue) => {
                  setIdProduct(newValue);
                  if (newValue === null) return;
                  setDataCreateReview({
                    ...dataCreateReview,
                    pcId: newValue._id,
                  });
                }}
                getOptionLabel={(option) => {
                  return (
                    option?.product_choice_review?.product?.item_name +
                    ` - ` +
                    option.product_choice_review?.product?.item_code +
                    +` - (` +
                    option.product_choice_review?.name +
                    `)`
                  );
                }}
                sx={{
                  m: 1,
                  width: "98%",
                  background: "#fff",
                  borderRadius: "16px",
                }}
                renderInput={(params) => (
                  <TextField
                    className="TextField-without-border-radius"
                    {...params}
                    label="สินค้า"
                    error={idProduct === null}
                    helperText={
                      idProduct === null ? "Please select product" : ""
                    }
                  />
                )}
              />
            </WrapperTextField>
          </WrapperText>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            {idProduct ? (
              <WrapperChooseProduct
                style={{ width: "48%", background: "#fff", border: "none" }}
              >
                <DivSection>
                  <ImageProduct
                    src={
                      idProduct?.product_choice_review?.group_image
                        ?.product_display_image
                    }
                  />
                </DivSection>
                <DivSection
                  style={{ flexDirection: "column", justifyContent: "center" }}
                >
                  <SpanProductName>
                    {idProduct?.product_choice_review?.product?.item_name}
                  </SpanProductName>
                  <SpanProductCode>
                    {idProduct?.product_choice_review?.product?.item_code}
                  </SpanProductCode>
                </DivSection>
                <LineDescription />
                <DivSection
                  style={{
                    justifyContent: "flex-start",
                    flexDirection: "column",
                  }}
                >
                  <SpanProductColor style={{ marginBottom: "12px" }}>
                    Color
                  </SpanProductColor>
                  <div
                    style={{ display: "flex", justifyContent: "flex-start" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        width: "75px",
                        padding: "4px",
                        marginRight: "8px",
                      }}
                    >
                      <ImgProductColor
                        src={
                          idProduct?.product_choice_review?.group_image
                            ?.product_display_image
                        }
                      />
                      <SpanColorName>
                        {idProduct?.product_choice_review?.color?.color_th}
                      </SpanColorName>
                      <SpanColorCode>
                        {idProduct?.product_choice_review?.name}
                      </SpanColorCode>
                    </div>
                  </div>
                </DivSection>
                <LineDescription />
                <DivSection
                  style={{
                    justifyContent: "flex-start",
                    flexDirection: "column",
                  }}
                >
                  <SpanProductColor style={{ marginBottom: "12px" }}>
                    Texture
                  </SpanProductColor>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      flexWrap: "wrap",
                    }}
                  >
                    <DivTexture>
                      {idProduct?.product_choice_review?.texture_type?.type_th}
                    </DivTexture>
                    {/* <DivTexture>Gloss</DivTexture> */}
                  </div>
                </DivSection>
                <LineDescription />
                <DivSection
                  style={{
                    justifyContent: "flex-start",
                    flexDirection: "column",
                  }}
                >
                  <SpanProductColor style={{ marginBottom: "12px" }}>
                    Size
                  </SpanProductColor>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      flexWrap: "wrap",
                    }}
                  >
                    <DivSize>
                      {idProduct?.product_choice_review?.size?.quantity ===
                      "size"
                        ? `${`W `}${
                            idProduct?.product_choice_review?.size?.width
                          } ${
                            idProduct?.product_choice_review?.size?.unit_width
                              .unit_en
                          } x ${`H `}${
                            idProduct?.product_choice_review?.size?.height
                          } ${
                            idProduct?.product_choice_review?.size?.unit_height
                              .unit_en
                          } x ${`D `}${
                            idProduct?.product_choice_review?.size?.thickness
                          } ${
                            idProduct?.product_choice_review?.size
                              ?.unit_thickness.unit_en
                          }`
                        : `${idProduct?.product_choice_review?.size?.capacity_size} ${idProduct?.product_choice_review?.size?.unit_capacity?.unit_en}`}
                    </DivSize>
                  </div>
                </DivSection>
              </WrapperChooseProduct>
            ) : (
              <WrapperChooseProduct
                style={{
                  width: "48%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "#6C6C70",
                  fontSize: "24px",
                }}
                bg={idProduct ? "#fff" : "#f2f1f3"}
              >
                <>Product</>
              </WrapperChooseProduct>
            )}

            <WrapperDataReview
              style={{
                width: "48%",
                background: "#fff",
                border: "none",
                padding: "0 16px",
              }}
            >
              <WrapperText style={{ marginBottom: "24px", marginTop: 0 }}>
                <TextField
                  placeholder="ชื่อ"
                  className="TextField-without-border-radius"
                  sx={{
                    width: "100%",
                    borderRadius: "16px",
                  }}
                  value={dataCreateReview.name}
                  onChange={(e) => {
                    setDataCreateReview({
                      ...dataCreateReview,
                      name: e.target.value,
                    });
                  }}
                  error={dataCreateReview.name === ""}
                  helperText={
                    dataCreateReview.name === "" ? "Please input name" : ""
                  }
                />
              </WrapperText>
              <Accordion
                sx={{
                  border: "none",
                  boxShadow: "none",
                  margin: 0,
                  "& > div": { margin: 0 },
                  ".Mui-expanded": { minHeight: "0px !important" },
                  "& > div > div": { margin: "0 !important" },
                  "&:before": { backgroundColor: "#fff" },
                }}
              >
                <AccordionSummary
                  sx={{ padding: 0, margin: 0 }}
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                      alignItems: "center",
                    }}
                  >
                    <Typography>คะแนนโดยรวม</Typography>

                    <WarpperRating>
                      <Rating
                        name="read-only"
                        size="large"
                        value={dataCreateReview?.rating?.total}
                        // readOnly
                        onChange={(e) =>
                          setDataCreateReview({
                            ...dataCreateReview,
                            rating: {
                              quality: Number(e.target.value),
                              service: Number(e.target.value),
                              install: Number(e.target.value),
                              deliver: Number(e.target.value),
                              total: Number(e.target.value),
                            },
                          })
                        }
                        sx={{
                          color: "#E6B558",
                        }}
                      />
                    </WarpperRating>
                  </div>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: 0 }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                      alignItems: "center",
                    }}
                  >
                    <TextRating>คุณภาพสินค้า</TextRating>
                    <WarpperRating>
                      <Rating
                        name="read-only"
                        size="large"
                        value={dataCreateReview?.rating?.quality}
                        onChange={(e) =>
                          setDataCreateReview({
                            ...dataCreateReview,
                            rating: {
                              ...dataCreateReview.rating,
                              quality: Number(e.target.value),
                            },
                          })
                        }
                        sx={{
                          color: "#E6B558",
                          margin: "auto 24px auto auto",
                        }}
                      />
                    </WarpperRating>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                      alignItems: "center",
                    }}
                  >
                    <TextRating>การติดตั้ง / การใช้งาน</TextRating>
                    <WarpperRating>
                      <Rating
                        name="read-only"
                        size="large"
                        value={dataCreateReview?.rating?.install}
                        onChange={(e) =>
                          setDataCreateReview({
                            ...dataCreateReview,
                            rating: {
                              ...dataCreateReview.rating,
                              install: Number(e.target.value),
                            },
                          })
                        }
                        sx={{
                          margin: "auto 24px auto auto",
                          color: "#E6B558",
                        }}
                      />
                    </WarpperRating>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                      alignItems: "center",
                    }}
                  >
                    <TextRating>การบริการ</TextRating>
                    <WarpperRating>
                      <Rating
                        name="read-only"
                        size="large"
                        value={dataCreateReview?.rating?.service}
                        onChange={(e) =>
                          setDataCreateReview({
                            ...dataCreateReview,
                            rating: {
                              ...dataCreateReview.rating,
                              service: Number(e.target.value),
                            },
                          })
                        }
                        sx={{
                          margin: "auto 24px auto auto",
                          color: "#E6B558",
                        }}
                      />
                    </WarpperRating>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                      alignItems: "center",
                    }}
                  >
                    <TextRating>การขนส่ง</TextRating>
                    <WarpperRating>
                      <Rating
                        name="read-only"
                        size="large"
                        value={dataCreateReview?.rating?.deliver}
                        onChange={(e) =>
                          setDataCreateReview({
                            ...dataCreateReview,
                            rating: {
                              ...dataCreateReview.rating,
                              deliver: Number(e.target.value),
                            },
                          })
                        }
                        sx={{
                          margin: "auto 24px auto auto",
                          color: "#E6B558",
                        }}
                      />
                    </WarpperRating>
                  </div>
                </AccordionDetails>
              </Accordion>

              {dataSuggest.length > 0 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    marginBottom: "24px",
                    flexWrap: "wrap",
                  }}
                >
                  {dataSuggest
                    .filter((fil) => fil.score === suggestVal)
                    .map((sug) => {
                      return (
                        <ButtonRate
                          selected={
                            sug._id === dataCreateReview.suggestId
                              ? true
                              : false
                          }
                          onClick={(e) =>
                            setDataCreateReview({
                              ...dataCreateReview,
                              suggestId: sug._id,
                            })
                          }
                        >
                          {sug.commentTh}
                        </ButtonRate>
                      );
                    })}
                </div>
              )}

              <WrapperTextField>
                <TextField
                  // InputProps={{
                  //   startAdornment: (
                  //     <InputAdornment position="start">
                  //       <ChatBubbleOutlineRoundedIcon />
                  //     </InputAdornment>
                  //   ),
                  // }}
                  placeholder={`คำแนะนำเพิ่มเติม`}
                  variant="outlined"
                  className="TextField-without-border-radius"
                  multiline={true}
                  inputProps={{ maxLength: 200 }}
                  rows={4}
                  sx={{
                    marginBottom: "24px",
                    textAlign: "left",
                    width: "100%",
                    fontSize: "0.875rem",
                  }}
                  value={dataCreateReview.comment}
                  onChange={(e) => {
                    setDataCreateReview({
                      ...dataCreateReview,
                      comment: e.target.value,
                    });
                  }}
                />
              </WrapperTextField>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "16px",
                }}
              >
                <span>อัปโหลดรูปภาพหรือวิดีโอ</span>
                <span>
                  {dataCreateReview?.groupImage !== undefined
                    ? Object.values(dataCreateReview?.groupImage)?.filter(
                        (data) => data !== "",
                      ).length
                    : 0}
                  /5
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                }}
              >
                {dataCreateReview.groupImage?.reviewImage1 === "" ||
                dataCreateReview.groupImage?.reviewImage1 === null ||
                dataCreateReview.groupImage?.reviewImage1 === undefined ? (
                  <UploadImage
                    callBackFile={(fileCallBlack) => {
                      setDataCreateReview({
                        ...dataCreateReview,
                        groupImage: {
                          ...dataCreateReview.groupImage,
                          reviewImage1: fileCallBlack,
                        },
                      });
                    }}
                    closeAlert={false}
                  >
                    <ImageEmpty style={{ marginLeft: 0 }}>
                      <PhotoCameraOutlinedIcon
                        sx={{
                          color: "#BCBCC0",
                          cursor: "pointer",
                        }}
                      />
                      <span style={{ fontSize: "0.65rem", color: "#6C6C70" }}>
                        อัพโหลดรูปภาพ
                      </span>
                    </ImageEmpty>
                  </UploadImage>
                ) : (
                  <div style={{ position: "relative" }}>
                    <UploadImage
                      callBackFile={(fileCallBlack) => {
                        setDataCreateReview({
                          ...dataCreateReview,
                          groupImage: {
                            ...dataCreateReview.groupImage,
                            reviewImage1: fileCallBlack,
                          },
                        });
                      }}
                      closeAlert={false}
                    >
                      <ImageCreateReview
                        style={{ marginLeft: 0 }}
                        src={
                          typeof dataCreateReview.groupImage?.reviewImage1 ===
                          "string"
                            ? dataCreateReview.groupImage?.reviewImage1
                            : dataCreateReview.groupImage?.reviewImage1
                                ?.fileData
                        }
                      />
                    </UploadImage>
                    <div
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        cursor: "pointer",
                      }}
                    >
                      <DeleteIcon
                        onClick={(e) =>
                          setDataCreateReview({
                            ...dataCreateReview,
                            groupImage: {
                              ...dataCreateReview.groupImage,
                              reviewImage1: "",
                            },
                          })
                        }
                        sx={{
                          background: "#fff",
                          borderRadius: "100%",
                          color: "#e04132",
                          padding: "3px",
                        }}
                      />
                    </div>
                  </div>
                )}
                {dataCreateReview.groupImage?.reviewImage2 === "" ||
                dataCreateReview.groupImage?.reviewImage2 === null ||
                dataCreateReview.groupImage?.reviewImage2 === undefined ? (
                  <UploadImage
                    callBackFile={(fileCallBlack) => {
                      setDataCreateReview({
                        ...dataCreateReview,
                        groupImage: {
                          ...dataCreateReview.groupImage,
                          reviewImage2: fileCallBlack,
                        },
                      });
                    }}
                    closeAlert={false}
                  >
                    <ImageEmpty style={{ marginLeft: 0 }}>
                      <PhotoCameraOutlinedIcon
                        sx={{
                          color: "#BCBCC0",
                          cursor: "pointer",
                        }}
                      />
                      <span style={{ fontSize: "0.65rem", color: "#6C6C70" }}>
                        อัพโหลดรูปภาพ
                      </span>
                    </ImageEmpty>
                  </UploadImage>
                ) : (
                  <div style={{ position: "relative" }}>
                    <UploadImage
                      callBackFile={(fileCallBlack) => {
                        setDataCreateReview({
                          ...dataCreateReview,
                          groupImage: {
                            ...dataCreateReview.groupImage,
                            reviewImage2: fileCallBlack,
                          },
                        });
                      }}
                      closeAlert={false}
                    >
                      <ImageCreateReview
                        style={{ marginLeft: 0 }}
                        src={
                          typeof dataCreateReview.groupImage?.reviewImage2 ===
                          "string"
                            ? dataCreateReview.groupImage?.reviewImage2
                            : dataCreateReview.groupImage?.reviewImage2
                                ?.fileData
                        }
                      />
                    </UploadImage>
                    <div
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        cursor: "pointer",
                      }}
                    >
                      <DeleteIcon
                        onClick={(e) =>
                          setDataCreateReview({
                            ...dataCreateReview,
                            groupImage: {
                              ...dataCreateReview.groupImage,
                              reviewImage2: "",
                            },
                          })
                        }
                        sx={{
                          background: "#fff",
                          borderRadius: "100%",
                          color: "#e04132",
                          padding: "3px",
                        }}
                      />
                    </div>
                  </div>
                )}
                {dataCreateReview.groupImage?.reviewImage3 === "" ||
                dataCreateReview.groupImage?.reviewImage3 === null ||
                dataCreateReview.groupImage?.reviewImage3 === undefined ? (
                  <UploadImage
                    callBackFile={(fileCallBlack) => {
                      setDataCreateReview({
                        ...dataCreateReview,
                        groupImage: {
                          ...dataCreateReview.groupImage,
                          reviewImage3: fileCallBlack,
                        },
                      });
                    }}
                    closeAlert={false}
                  >
                    <ImageEmpty style={{ marginLeft: 0 }}>
                      <PhotoCameraOutlinedIcon
                        sx={{
                          color: "#BCBCC0",
                          cursor: "pointer",
                        }}
                      />
                      <span style={{ fontSize: "0.65rem", color: "#6C6C70" }}>
                        อัพโหลดรูปภาพ
                      </span>
                    </ImageEmpty>
                  </UploadImage>
                ) : (
                  <div style={{ position: "relative" }}>
                    <UploadImage
                      callBackFile={(fileCallBlack) => {
                        setDataCreateReview({
                          ...dataCreateReview,
                          groupImage: {
                            ...dataCreateReview.groupImage,
                            reviewImage3: fileCallBlack,
                          },
                        });
                      }}
                      closeAlert={false}
                    >
                      <ImageCreateReview
                        style={{ marginLeft: 0 }}
                        src={
                          typeof dataCreateReview.groupImage?.reviewImage3 ===
                          "string"
                            ? dataCreateReview.groupImage?.reviewImage3
                            : dataCreateReview.groupImage?.reviewImage3
                                ?.fileData
                        }
                      />
                    </UploadImage>
                    <div
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        cursor: "pointer",
                      }}
                    >
                      <DeleteIcon
                        onClick={(e) =>
                          setDataCreateReview({
                            ...dataCreateReview,
                            groupImage: {
                              ...dataCreateReview.groupImage,
                              reviewImage3: "",
                            },
                          })
                        }
                        sx={{
                          background: "#fff",
                          borderRadius: "100%",
                          color: "#e04132",
                          padding: "3px",
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  marginBottom: "24px",
                }}
              >
                {dataCreateReview.groupImage?.reviewImage4 === "" ||
                dataCreateReview.groupImage?.reviewImage4 === null ||
                dataCreateReview.groupImage?.reviewImage4 === undefined ? (
                  <UploadImage
                    callBackFile={(fileCallBlack) => {
                      setDataCreateReview({
                        ...dataCreateReview,
                        groupImage: {
                          ...dataCreateReview.groupImage,
                          reviewImage4: fileCallBlack,
                        },
                      });
                    }}
                    closeAlert={false}
                  >
                    <ImageEmpty style={{ marginLeft: 0 }}>
                      <PhotoCameraOutlinedIcon
                        sx={{
                          color: "#BCBCC0",
                          cursor: "pointer",
                        }}
                      />
                      <span style={{ fontSize: "0.65rem", color: "#6C6C70" }}>
                        อัพโหลดรูปภาพ
                      </span>
                    </ImageEmpty>
                  </UploadImage>
                ) : (
                  <div style={{ position: "relative" }}>
                    <UploadImage
                      callBackFile={(fileCallBlack) => {
                        setDataCreateReview({
                          ...dataCreateReview,
                          groupImage: {
                            ...dataCreateReview.groupImage,
                            reviewImage4: fileCallBlack,
                          },
                        });
                      }}
                      closeAlert={false}
                    >
                      <ImageCreateReview
                        style={{ marginLeft: 0 }}
                        src={
                          typeof dataCreateReview.groupImage?.reviewImage4 ===
                          "string"
                            ? dataCreateReview.groupImage?.reviewImage4
                            : dataCreateReview.groupImage?.reviewImage4
                                ?.fileData
                        }
                      />
                    </UploadImage>
                    <div
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        cursor: "pointer",
                      }}
                    >
                      <DeleteIcon
                        onClick={(e) =>
                          setDataCreateReview({
                            ...dataCreateReview,
                            groupImage: {
                              ...dataCreateReview.groupImage,
                              reviewImage4: "",
                            },
                          })
                        }
                        sx={{
                          background: "#fff",
                          borderRadius: "100%",
                          color: "#e04132",
                          padding: "3px",
                        }}
                      />
                    </div>
                  </div>
                )}
                {dataCreateReview.groupImage?.reviewVideo === "" ||
                dataCreateReview.groupImage?.reviewVideo === null ||
                dataCreateReview.groupImage?.reviewVideo === undefined ? (
                  <UploadVideo
                    callBackFile={(fileCallBlack) => {
                      setDataCreateReview({
                        ...dataCreateReview,
                        groupImage: {
                          ...dataCreateReview.groupImage,
                          reviewVideo: fileCallBlack,
                        },
                      });
                    }}
                    closeAlert={false}
                  >
                    <ImageEmpty>
                      <VideocamOutlinedIcon
                        sx={{
                          color: "#BCBCC0",
                          cursor: "pointer",
                        }}
                      />
                      <span style={{ fontSize: "0.65rem", color: "#6C6C70" }}>
                        อัพโหลดวิดีโอ
                      </span>
                    </ImageEmpty>
                  </UploadVideo>
                ) : (
                  <div style={{ position: "relative" }}>
                    <UploadVideo
                      callBackFile={(fileCallBlack) => {
                        setDataCreateReview({
                          ...dataCreateReview,
                          groupImage: {
                            ...dataCreateReview.groupImage,
                            reviewVideo: fileCallBlack,
                          },
                        });
                      }}
                      closeAlert={false}
                    >
                      <div style={{ position: "relative" }}>
                        <VideoCreateReview
                          // controls
                          muted
                          style={{ marginLeft: 0 }}
                          src={
                            typeof dataCreateReview.groupImage?.reviewVideo ===
                            "string"
                              ? dataCreateReview.groupImage?.reviewVideo
                              : dataCreateReview.groupImage?.reviewVideo
                                  ?.fileData
                          }
                        />
                        <div
                          style={{
                            width: "100px",
                            height: "100px",
                            background: "#000",
                            position: "absolute",
                            top: 0,
                            opacity: 0.5,
                            left: 0,
                            borderRadius: "8px",
                            cursor: "pointer",
                          }}
                        >
                          <PlayCircleIcon
                            sx={{
                              color: "#fff",
                              cursor: "pointer",
                              position: "absolute",
                              top: "35%",
                              left: "30%",
                              width: "35px",
                              height: "35px",
                              margin: "auto",
                            }}
                          />
                        </div>
                      </div>
                    </UploadVideo>
                    <div
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        cursor: "pointer",
                      }}
                    >
                      <DeleteIcon
                        onClick={(e) =>
                          setDataCreateReview({
                            ...dataCreateReview,
                            groupImage: {
                              ...dataCreateReview.groupImage,
                              reviewVideo: "",
                            },
                          })
                        }
                        sx={{
                          background: "#fff",
                          borderRadius: "100%",
                          color: "#e04132",
                          padding: "3px",
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>
              <WrapperTextField>
                <TextField
                  placeholder={`ตอบกลับ`}
                  variant="outlined"
                  className="TextField-without-border-radius"
                  multiline={true}
                  rows={4}
                  sx={{
                    m: 0,
                    textAlign: "left",
                    width: "100%",
                    fontSize: "0.875rem",
                  }}
                  value={dataCreateReview?.reply?.reply_text}
                  onChange={(text) => {
                    setTextReply(text.target.value);
                    setDataCreateReview({
                      ...dataCreateReview,
                      reply: {
                        ...dataCreateReview.reply,
                        reply_text: text.target.value,
                      },
                    });
                  }}
                />
              </WrapperTextField>
            </WrapperDataReview>
          </div>
        </WrapperModalInside>
        <div style={{ display: "flex" }}>
          <Button
            onClick={() => {
              setIsVisibleConfirmCancel(true); //showmodal alert save
            }}
            className="Button-New-Brand"
            style={{
              background: "#e04132",
              color: "#fff",
              borderRadius: "16px",
              margin: "8px 16px 8px auto",
              display: "flex",
              width: "130px",
              height: "42px",
            }}
          >
            ยกเลิก
          </Button>
          <Button
            onClick={() => {
              setIsVisibleConfirmReview(true); //showmodal alert approve
            }}
            disabled={idProduct === null || dataCreateReview.name.length === 0}
            className="Button-New-Brand"
            style={{
              background:
                idProduct === null || dataCreateReview.name.length === 0
                  ? "#bcbcc0"
                  : "#e04132",
              color: "#fff",
              borderRadius: "16px",
              margin: "8px auto 8px 16px",
              display: "block",
              width: "130px",
              height: "42px",
            }}
          >
            รีวิวสินค้า
          </Button>
        </div>
        {isVisibleConfirmReview ? (
          <ModalConfirm
            style={{ borderRadius: "24px" }}
            title={
              id
                ? "คุณต้องการแก้ไขรีวิวสินค้านี้ใช่หรือไม่?"
                : "คุณต้องการสร้างรีวิวสินค้านี้ใช่หรือไม่?"
            }
            callBack={(value) => {
              value === false
                ? setIsVisibleConfirmReview(value)
                : onCreateReview();
            }}
            textConfirm={`Confirm`}
            // icon={"delete"}
          />
        ) : null}
        {isVisibleConfirmCancel ? (
          <ModalConfirm
            style={{ borderRadius: "24px" }}
            title={"คุณต้องการออกจากหน้านี้หรือไม่?"}
            callBack={(value) =>
              value === false ? setIsVisibleConfirmCancel(value) : closeModal()
            }
            textConfirm={`Confirm`}
            // icon={"delete"}
          />
        ) : null}
        {isVisibleAlert && (
          <WrapperAlert>
            <DivAlert>
              <Alert
                className="MuiPaper-root-MuiAlert-root"
                severity={typeAlert}
              >
                {titleAlert}
              </Alert>
            </DivAlert>
          </WrapperAlert>
        )}
      </WrapperModal>
      {isLoading && <Loading />}
    </Modal>
  );
}

export default ModalCreateReview;
